import { apiWrapper } from "@/services/api";
import store from "@/store/index";
import mfittService from "@/services/MFITT";

export const getTicketPrice = async (selectedTrainId) => {
  let response;
  try {
    const inputtedInfoOnBooking = store.getters["MFITT/inputtedInfoOnBooking"];
    // 列車の空席情報(空席照会時に入力した乗車日と異なる場合があるので、boarding_dateはこちらを使う)
    const vacancyInquiry = store.getters["MFITT/vacancyInquiry"];

    // 区間(発着照会を利用した場合、入力した区間と異なる場合があるので、こちらを使う)
    const selectedTrainInfo = vacancyInquiry.train_info[selectedTrainId];

    let specialDesignation = inputtedInfoOnBooking.special_designation.id;
    // 前展望/後展望の場合は、special_designation.idを7(座席指定)に変更
    if (
      inputtedInfoOnBooking.special_designation.id == 1 ||
      inputtedInfoOnBooking.special_designation.id == 2
    ) {
      specialDesignation = 7;
    }
    response = await apiWrapper(
      "GET",
      `/mfitt/limited_express_ticket_price_inquiry?boarding_date=${mfittService.convertDateFormatForApi(
        vacancyInquiry.boarding_date
      )}&from_station_id=${selectedTrainInfo.from_station.id}&to_station_id=${
        selectedTrainInfo.to_station.id
      }&special_designation=${specialDesignation}`
    );
    console.log("getTicketPrice response.data :>> ", response.data);
    store.commit("MFITT/setTicketPrice", response.data);
  } catch (err) {
    console.log('ERROR"" getTicketPrice():', err);
    throw err;
  }
  return response.data;
};
